import(/* webpackMode: "eager", webpackExports: ["PostHogCookieBanner"] */ "/Users/tj-index/LP-Finzy/components/posthog-cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/Users/tj-index/LP-Finzy/components/posthog-provider.tsx");
;
import(/* webpackMode: "eager" */ "/Users/tj-index/LP-Finzy/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager" */ "/Users/tj-index/LP-Finzy/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/Users/tj-index/LP-Finzy/node_modules/swr/dist/index/config-client-Bi4rgVRk.mjs");
